var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDoublePrevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26445 8L8.41132 2.70156C8.47538 2.62031 8.41757 2.5 8.31288 2.5H7.10507C7.02851 2.5 6.95507 2.53594 6.9082 2.59531L2.91913 7.69219C2.85005 7.78022 2.8125 7.88888 2.8125 8.00078C2.8125 8.11268 2.85005 8.22135 2.91913 8.30937L6.9082 13.4047C6.95507 13.4656 7.02851 13.5 7.10507 13.5H8.31288C8.41757 13.5 8.47538 13.3797 8.41132 13.2984L4.26445 8ZM9.01445 8L13.1613 2.70156C13.2254 2.62031 13.1676 2.5 13.0629 2.5H11.8551C11.7785 2.5 11.7051 2.53594 11.6582 2.59531L7.66913 7.69219C7.60005 7.78022 7.5625 7.88888 7.5625 8.00078C7.5625 8.11268 7.60005 8.22135 7.66913 8.30937L11.6582 13.4047C11.7051 13.4656 11.7785 13.5 11.8551 13.5H13.0629C13.1676 13.5 13.2254 13.3797 13.1613 13.2984L9.01445 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoublePrevIcon);
export default __webpack_public_path__ + "static/media/arrowDoublePrevIcon.df550cb139ca38d35dd8cfa0400f6c55.svg";
export { ForwardRef as ReactComponent };